class BasicAppearanceConfig {
    protected dashboard: Dashboard;

    fontColor: KnockoutObservable<string>;
    backgroundColor: KnockoutObservable<string>;

    fontColorUI: KnockoutComputed<string>;
    backgroundColorUI: KnockoutComputed<string>;

    constructor(data: any, dashboard: Dashboard) {
        this.dashboard = dashboard;
        
        this.fontColor = ko.observable(data.fontColor);
        this.fontColorUI = ko.computed(() => {
            if (!this.fontColor()) {
                return "#333"; //this.dashboard.appearance.widgetDefaultBackgroundColor();
            }
            else {
                return this.fontColor();
            }
        }, this);

        this.backgroundColor = ko.observable(data.backgroundColor);
        this.backgroundColorUI = ko.computed(() => {
            if (this.backgroundColor() === "#ffffff" || this.backgroundColor() === null) {
                return this.dashboard.appearance.widgetDefaultBackgroundColor() ?? "#ffffff";
            }
            else {
                return this.backgroundColor();
            }
        }, this);
    }
}